import { useMemo } from 'react';
import FirmsService from 'services/firms';
import { Logger } from 'utilities';

export type FirmAssetSignedUrlResponse = {
  url: string;
  key: string;
  public_url: string;
};

const useFirmAssets = () => {
  const filesService = useMemo(() => new FirmsService(), []);

  const getFirmAssetSignedUrl = async (
    firmId: number,
    assetType: string
  ): Promise<unknown> => {
    try {
      return (await filesService.getFirmAssetSignedUrl(firmId, assetType)) as FirmAssetSignedUrlResponse;
    } catch (error) {
      Logger.error('Error getting firm asset signed url', error);
      return error;
    }
  };

  const uploadImageFile = async (url: string, file: File): Promise<unknown> => {
    const otherParams = {
      method: 'PUT',
      body: file,
      headers: {
        'Content-Type': file.type ?? 'application/octet-stream',
      },
    };

    try {
      return await fetch(url, otherParams).then(res => res);
    } catch (error) {
      Logger.error('Error uploading image file', error);
      return error;
    }
  };
  return { getFirmAssetSignedUrl, uploadImageFile };
};

export default useFirmAssets;
